import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { SPARTACUS_UK_TIMEZONE } from 'src/constants/spartacus'
import { formatFunnelRate } from './crowsNestFunnel'

dayjs.extend(utc)
dayjs.extend(timezone)

const CENSUS_PLAN = 'Free'

/** Sales-facing rows — keys match Express census totals / shares. */
export const CROWS_NEST_CENSUS_ROWS = Object.freeze([
  {
    key: 'belowMilestone',
    label: '0–2 suppliers',
    countFrom: totals => totals.suppliers?.belowMilestone,
    shareKey: 'belowMilestone',
  },
  {
    key: 'atOrAboveMilestone',
    label: '3+ suppliers',
    countFrom: totals => totals.suppliers?.atOrAboveMilestone,
    shareKey: 'atOrAboveMilestone',
  },
  {
    key: 'dormant',
    label: 'Dormant',
    countFrom: totals => totals.dormant,
    shareKey: 'dormant',
  },
  {
    key: 'unadoptedRecipes',
    label: 'Unadopted recipes',
    countFrom: totals => totals.unadopted?.recipes,
    shareKey: 'unadoptedRecipes',
  },
  {
    key: 'unadoptedStockTakes',
    label: 'Unadopted stock takes',
    countFrom: totals => totals.unadopted?.stockTakes,
    shareKey: 'unadoptedStockTakes',
  },
  {
    key: 'unadoptedParLevels',
    label: 'Unadopted par levels',
    countFrom: totals => totals.unadopted?.parLevels,
    shareKey: 'unadoptedParLevels',
  },
  {
    key: 'unadoptedRecipesStockAndPar',
    label: 'Unadopted recipes, stock, and par',
    countFrom: totals => totals.unadopted?.recipesStockAndPar,
    shareKey: 'unadoptedRecipesStockAndPar',
  },
])

export function formatCountOfVenues(count, venues) {
  return `${Number(count) || 0} of ${Number(venues) || 0}`
}

export function formatCensusAsOf(asOf, plan = CENSUS_PLAN) {
  const planLabel =
    plan && String(plan).trim() ? String(plan).trim() : 'All plans'
  if (!asOf) {
    return `Snapshot now · ${planLabel}`
  }
  const when = dayjs(asOf).tz(SPARTACUS_UK_TIMEZONE)
  if (!when.isValid()) {
    return `Snapshot now · ${planLabel}`
  }
  return `As of ${when.format('D MMM YYYY')} · ${planLabel}`
}

export function mapLadderCensus(response = {}) {
  const totals = response.totals || {}
  const venues = Number(totals.venues) || 0
  const shares = totals.shares || {}
  const plan = response.filters?.plan || CENSUS_PLAN

  return {
    definition: response.definition || null,
    filters: response.filters || {},
    asOf: response.asOf || null,
    plan,
    venues,
    scopeLabel: formatCensusAsOf(response.asOf, plan),
    rows: CROWS_NEST_CENSUS_ROWS.map(spec => {
      const count = Number(spec.countFrom(totals)) || 0
      const share = shares[spec.shareKey] ?? null
      return {
        key: spec.key,
        label: spec.label,
        count,
        share,
        ofVenues: formatCountOfVenues(count, venues),
        shareLabel: formatFunnelRate(share),
      }
    }),
  }
}
